import DigitalMarketingServicePage from '../digital-marketing/DigitalMarketingServicePage';
import { getDigitalMarketingService } from '../digital-marketing/services';

const SeoServices = () => {
  const service = getDigitalMarketingService('seo-services');
  if (!service) return null;
  return <DigitalMarketingServicePage service={service} />;
};

export default SeoServices;
